import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Card, Btn, Badge, AInput, ASelect } from "../AdminUI";
import { Plus, Trash2, MapPin } from "lucide-react";

export default function ServiceAreasAdmin() {
  const [items, setItems] = useState([]);
  const [edit, setEdit] = useState(null);
  const load = () => api.get("/admin/service-areas").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const blank = { name: "", state: "FL", status: "pending", primary: false };

  const saveA = async () => {
    try {
      if (edit.id) await api.patch(`/admin/service-areas/${edit.id}`, edit);
      else await api.post("/admin/service-areas", edit);
      toast.success("Saved"); setEdit(null); load();
    } catch { toast.error("Failed"); }
  };
  const del = async (id) => { if (!window.confirm("Delete area?")) return; await api.delete(`/admin/service-areas/${id}`); load(); };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="font-head font-extrabold text-3xl text-[var(--navy)] uppercase tracking-tight">Service Areas</h1>
        <Btn onClick={() => setEdit(blank)} data-testid="add-area"><Plus className="w-4 h-4" /> Add Area</Btn>
      </div>
      <div className="bg-blue-50 border border-blue-200 rounded-xl p-3 text-sm text-blue-800">Only areas marked "confirmed" appear publicly. Don't publish cities until confirmed.</div>

      {edit && (
        <Card title={edit.id ? "Edit Area" : "New Area"}>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <AInput label="City" value={edit.name} onChange={(e) => setEdit({ ...edit, name: e.target.value })} />
            <AInput label="State" value={edit.state} onChange={(e) => setEdit({ ...edit, state: e.target.value })} />
            <ASelect label="Status" value={edit.status} options={["confirmed", "pending"]} onChange={(e) => setEdit({ ...edit, status: e.target.value })} />
          </div>
          <label className="flex items-center gap-2 text-sm mt-3"><input type="checkbox" checked={edit.primary} onChange={(e) => setEdit({ ...edit, primary: e.target.checked })} className="w-4 h-4 accent-[var(--action)]" /> Primary location</label>
          <div className="flex gap-2 mt-4"><Btn onClick={saveA}>Save</Btn><Btn variant="ghost" onClick={() => setEdit(null)}>Cancel</Btn></div>
        </Card>
      )}

      <Card>
        <div className="divide-y divide-gray-100">
          {items.map((a) => (
            <div key={a.id} className="flex items-center justify-between py-3">
              <div className="flex items-center gap-2"><MapPin className="w-4 h-4 text-[var(--action)]" /><span className="font-semibold text-[var(--navy)]">{a.name}, {a.state}</span>
                {a.primary && <Badge color="red">Primary</Badge>}<Badge color={a.status === "confirmed" ? "green" : "amber"}>{a.status}</Badge></div>
              <div className="flex gap-2"><Btn variant="ghost" onClick={() => setEdit(a)}>Edit</Btn><Btn variant="danger" onClick={() => del(a.id)}><Trash2 className="w-4 h-4" /></Btn></div>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
}
